<template>
    <div>
        <el-row>
        <el-col :span="10">
        <el-radio-group v-model="filter.type"
                                size="mini">
                    <template>
                        <el-radio-button :label="null">{{$t('common.all')}}</el-radio-button>
                        <el-radio-button v-for="category in categories"
                                         :label="category.status"
                                         :key="category.status">{{category.total}} {{$i18n.locale == 'en' ? category.name : category.nameFr}}</el-radio-button>
                    </template>
                </el-radio-group>
        </el-col>
        <el-col :span="14">
        <el-row :gutter="10">
           
        <el-col :md="8" :lg="6">
                    <chain-selector v-model="filter.chainId"></chain-selector>
                </el-col>
            <el-col :md="8" :lg="6" >
                <customer-selector v-model="filter.customerId" />
            </el-col>
            <el-col :md="8" :lg="6" >
                <el-input v-model="filter.ticket"
                          :placeholder="$t('serviceTickets.ticketNumber')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :md="8" :lg="6" >
                <el-input v-model="filter.city"
                          :placeholder="$t('serviceTickets.city')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :md="6" :lg="6" >
                <el-input v-model="filter.state"
                          :placeholder="$t('serviceTickets.state')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
           
        
            <el-col :md="8" :lg="6"  >
                <el-input v-model="filter.serialNumber"
                          :placeholder="$t('serviceTickets.serialNumber')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :md="8" :lg="6" >
                <el-input v-model="filter.serviceCompany"
                          :placeholder="$t('serviceTickets.lookUpServiceCompany')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :md="8" :lg="6" >
                <el-date-picker v-model="filter.dateFrom"
                                type="date"
                                :placeholder="$t('serviceTickets.fromRaisedOnDate')"
                                style="width:100%;"></el-date-picker>
            </el-col>
            <el-col :md="8" :lg="6" >
                <el-date-picker v-model="filter.dateTo"
                                type="date"
                                :placeholder="$t('serviceTickets.toRaisedOnDate')"
                                style="width:100%;"></el-date-picker>
            </el-col>
            <el-col :md="8" :lg="6" >
                <el-select class="selector" v-model="filter.source" placeholder="Source" clearable>
                    <el-option v-for="item in selfServiceOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value" />
                </el-select>
                </el-col> 
                
                <el-col :md="8" :lg="6" :justify="end" >
                 <el-button :loading="exporting"
                           icon="el-icon-download"
                           @click="download"
                           v-if="$isAdmin">{{$t('serviceTickets.export')}}</el-button>
            </el-col>
            </el-row>
            </el-col>
        </el-row>
        <!-- Escallation Report Table-->
        <el-table size="mini"
                  :data="tickets"
                  v-loading="loading"
                  class="tickets-table"
                  @sort-change="sortServiceTickets"
                  v-if="filter.type == 5" key="1"
                  :row-class-name="tableRowEscalationTime">
            <el-table-column prop="id" width="90"
                             label="Ticket #"
                             sortable="custom">
            </el-table-column>
            <el-table-column prop="customer"
                             label="Customer #"
                             sortable="custom"></el-table-column>
            <el-table-column prop="raisedOn"
                             label="Raised On"
                             sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.raisedOn | datetime}}
                </template>
            </el-table-column>
            <el-table-column prop="serialNumber" label="Serial #"
                             sortable="custom"></el-table-column>
            <el-table-column property="workflowStage" label="Workflow Stage"
                             sortable="custom">
                <template slot-scope="scope">
                    <span v-if="scope.row.workflowStage === 1">Dispatched</span>
                    <span v-else-if="scope.row.workflowStage === 2">Pending Tech ETA (1)</span>
                    <span v-else-if="scope.row.workflowStage === 3">Tech ETA (1)</span>
                    <span v-else-if="scope.row.workflowStage === 4">Tech onsite (1)</span>
                    <span v-else-if="scope.row.workflowStage === 5">Parts needed</span>
                    <span v-else-if="scope.row.workflowStage === 6">Pending Parts Order / Parts Ordered</span>
                    <span v-else-if="scope.row.workflowStage === 7">Sales Order #</span>
                    <span v-else-if="scope.row.workflowStage === 8">Parts Shipped</span>
                    <span v-else-if="scope.row.workflowStage === 9">Tracking # (allow for more than one)</span>
                    <span v-else-if="scope.row.workflowStage === 10">Parts Estimated delivery (ETD)</span>
                    <span v-else-if="scope.row.workflowStage === 11">Parts Delivered</span>
                    <span v-else-if="scope.row.workflowStage === 12">Pending Tech ETA (2)</span>
                    <span v-else-if="scope.row.workflowStage === 13">Tech ETA (2)</span>
                    <span v-else-if="scope.row.workflowStage === 14">Tech onsite (2)</span>
                    <span v-else-if="scope.row.workflowStage === 15">Job Completed</span>
                    <span v-else></span>
                </template>
            </el-table-column>
            <el-table-column property="timeInWorkflowStage" label="Time In Workflow Stage"
                             sortable="custom">
                <template slot-scope="scope">
                    {{formattedHour(scope.row.timeInWorkflowStage)}}
                </template>
            </el-table-column>
            <el-table-column prop="escalatedOn"
                             label="Escalated On"
                             sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.escalatedOn | datetime}}
                </template>
            </el-table-column>
            <el-table-column prop="escalatedBy"
                             label="Escalated By"
                             sortable="custom"></el-table-column>
            <el-table-column prop="daysSinceRaised"
                             label="Days since raised"
                             sortable="custom"></el-table-column>
            <el-table-column prop="escalationGauge"
                             label="Escalation Gauge"
                             sortable="custom"></el-table-column>
            <el-table-column prop="lastUpdatedBy"
                             label="Last Update by"
                             sortable="custom"></el-table-column>
            <el-table-column prop="lastUpdatedTime"
                             label="Last Update date & time"
                             sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.lastUpdatedTime | datetime}}
                </template>
            </el-table-column>
            <el-table-column prop="lastComment"
                             label="Last Comment"
                             sortable="custom"
                             :formatter="truncateComment"></el-table-column>
            <el-table-column prop="escalationContactName"
                             label="Escalation Contact Name"
                             sortable="custom"></el-table-column>
            <el-table-column prop="escalationContactNumber"
                             label="Escalation Contact #"
                             sortable="custom"></el-table-column>
            <el-table-column label="Operations"
                             fixed="right"
                             width="160">
                <template slot-scope="scope">
                    <el-button size="mini"
                               @click="editTicket(scope.row.id)">
                        <i class="el-icon-view"></i>
                    </el-button>
                </template>

            </el-table-column>
        </el-table>
        <el-table size="mini"
                  :data="tickets"
                  v-loading="loading"
                  class="tickets-table tablewithshading"
                  @sort-change="sortServiceTickets"
                  v-else key="2">
            <el-table-column prop="id" width="90"
                             :label="$t('serviceTickets.ticketNumber')"
                             sortable="custom"></el-table-column>
            <el-table-column prop="confirmation" width="120"
                             :label="$t('serviceTickets.confirmation')"
                             sortable="custom"></el-table-column>
            <el-table-column prop="openedBy"
                             :label="$t('serviceTickets.openedBy')"
                             sortable="custom"></el-table-column>
            <el-table-column prop="customer"
                             :label="$t('serviceTickets.customerNumber')"
                             sortable="custom"></el-table-column>
            <el-table-column :label="$t('serviceTickets.raisedOn')"
                             sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.raisedOn | datetime}}
                </template>
            </el-table-column>
            <el-table-column prop="serialNumber" :label="$t('serviceTickets.serialNumber')"
                             sortable="custom"></el-table-column>
            <el-table-column :label="$t('serviceTickets.codeDescription')"
                             min-width="175">
                <template slot-scope="scope">
                    <el-tooltip v-for="complaint in scope.row.complaints"
                                :key="complaint.code"
                                effect="dark"
                                :content="calculateNameToBeShown(complaint)"
                                placement="top">
                        <el-tag type="info"
                                size="small"
                                :disable-transitions="true"
                                style="margin-right:5px;">{{ calculateNameToBeShown(complaint) }}</el-tag>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column v-if="$i18n.locale == 'en'" prop="status" width="100"
                             :label="$t('serviceTickets.status')"
                             sortable="custom"></el-table-column>
            <el-table-column v-else prop="statusFr" width="100"
                             :label="$t('serviceTickets.status')"
                             sortable="custom"></el-table-column>
            <el-table-column prop="serviceCompany"
                             :label="$t('serviceTickets.serviceCompany')"
                             sortable="custom"></el-table-column>
            <el-table-column :label="$t('serviceTickets.serviceCompanyPhone')"
                             sortable="custom">
                <template slot-scope="scope">
                    <a :href="'callto:'+scope.row.serviceCompanyPhone">{{scope.row.serviceCompanyPhone}}</a>
                </template>
            </el-table-column>
            <el-table-column label="Source">
                <template slot-scope="scope">
                    {{ scope.row.sourceRequest }}
                </template>
            </el-table-column>
            <el-table-column prop="sendHours" width="90"
                             :label="$t('serviceTickets.ticketSent')"
                             sortable="custom"
                             v-if="filter.type == 99"></el-table-column>
            <el-table-column :label="$t('serviceTickets.operations')"
                             fixed="right"
                             width="160">
                <template slot-scope="scope">
                    <el-button size="mini"
                               @click="editTicket(scope.row.id)">
                        <i class="el-icon-view"></i>
                    </el-button>
                </template>

            </el-table-column>
        </el-table>
        <create-service-ticket-dialog :ticketId="ticketToEdit" :visible="createServiceTicketDialogVisible" @dialogClosed="createServiceTicketDialogVisible = false"></create-service-ticket-dialog>
        <el-pagination class="pager"
                       v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>

        <service-ticket-details-dialog :ticketId="ticketToEdit"
                                       :visible="dialogVisible"
                                       @dialogClosed="editFinished"
                                       @updated="ticketUpdated"></service-ticket-details-dialog>
    </div>
</template>

<script>
    import {
        CustomerSelector,

    } from "@/app/shared/components";
    import ServiceTicketDetailsDialog from "./ServiceTicketDetailsDialog";
    import SendEmailDialog from "./SendEmailDialog";
    import CreateServiceTicketDialog from "./CreateServiceTicketDialog";
    import api from "../api";
    import ChainSelector from "./../../masters/customers/components/ChainSelector.vue";

    export default {
        name: "service-ticket-list",
        components: {
            ServiceTicketDetailsDialog,
            CustomerSelector,
            CreateServiceTicketDialog,
            ChainSelector
        },
        data() {
            return {
                tickets: [],
                loading: true,
                selfServiceOptions: [{ value: "external", label: 'External' }, { value: "internal", label: 'Internal' }],
                dialogVisible: false,
                ticketToEdit: null,
                createServiceTicketDialogVisible: false,
                filter: {
                    type: this.$route.params.status || null,
                    customerId: "",
                    ticket: "",
                    city: "",
                    state: "",
                    serviceCompany: "",
                    fromDate: "",
                    toDate: "",
                    serialNumber: "",
                    source: "",
                    chainId: undefined,
                },
                sorting: {},
                currentPage: 1,
                total: 0,
                categories: [],
                openTotal: null,
                closedTotal: null,
                flaggedTotal: null,
                flaggedClosedTotal: null,
                escalationTotal: null,
                escalationClosedTotal: null,
                postInstallInstallTotal: null,
                exporting: false,
                emailTicketId: this.$route.params.ticketId
            };
        },
        watch: {
            filter: {
                deep: true,
                handler: function () {
                    if (this.filter.status === null && this.$route.params.status != null) {
                        window.location.href = "/#/service-tickets";
                    }
                    this.loadTickets();
                }
            }
        },
        created() {
            this.loadTickets();
            this.loadCategories();
        },
        methods: {
            truncateComment(row, column, cellValue) {
                const limit = 40;
                return this.truncate(cellValue, limit);
            },
            truncate(value, limit) {
                if (!value) return '';
                if (value.length <= limit) return value;
                return value.substring(0, limit) + '...';
            },
            formattedHour(decimalHour) {
                let hour = Math.floor(decimalHour);
                let minute = Math.round((decimalHour - hour) * 60);
                minute = (minute < 10 ? '0' : '') + minute;
                return `${hour} hrs: ${minute} min`;
            },
            showCreateServiceTicketDialog(id) {
                this.ticketToEdit = id;
                this.createServiceTicketDialogVisible = true;
            },
            ticketUpdated() {
                this.loadTickets();
            },
            loadTickets() {
                this.loading = true;
                api
                    .getTickets(this.currentPage, this.filter, this.sorting)
                    .then(response => {
                        this.loading = false;
                        this.tickets = response.data.items;
                        this.total = response.data.total;
                    });
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadTickets();
            },
            editTicket(id) {
                this.ticketToEdit = id;
                this.dialogVisible = true;
            },
            copyTicket(id) {
                this.ticketToEdit = id;
                this.dialogVisible = true;
            },
            editFinished() {
                this.ticketToEdit = null;
                this.dialogVisible = false;
            },
            loadCategories() {
                this.loading = true;
                api.getCategories().then(response => {
                    this.loading = false;
                    this.categories = response.data;
                });
            },
            download() {
                this.exporting = true;
                if (!this.filter.dateFrom && !this.filter.dateTo) {
                    var dateToday = new Date();
                    var day = dateToday.getDate();
                    var month = Number(dateToday.getMonth() + 1);
                    var year = Number(dateToday.getFullYear());
                    this.$confirm(
                        this.$t('common.theExportWillBeGeneratedForAPeriodOfOneYear') + (year - 1) + '/' + month + '/' + day + " - " + year + '/' + month + '/' + day + this.$t('common.sinceTheDateRangeWasNotSelectedPleaseConfirm'),
                        "Warning",
                        {
                            confirmButtonText: this.$t('common.OK'),
                            cancelButtonText: this.$t('common.cancel'),
                            type: "warning"
                        }
                    )
                        .then(() => {
                            api.download(this.filter).then(() => {
                                this.exporting = false;
                                this.$message({
                                    title: this.$t('common.success'),
                                    message: this.$t('common.exportWasGeneratedSuccesfully'),
                                    type: "success"
                                });
                            });
                        }).catch(_ => { this.exporting = false; });

                }
                else {
                    api.download(this.filter).then(() => {
                        this.exporting = false;
                        this.$message({
                            title: this.$t('common.success'),
                            message: this.$t('common.exportWasGeneratedSuccesfully'),
                            type: "success"
                        });
                    });
                }
            },
            sortServiceTickets(sort) {
                let sortBy = sort.prop;
                if (!sortBy && sort.column != null) {
                    sortBy = sort.column.label;
                }
                let sortOrder = sort.order;
                this.sorting = {
                    sortBy,
                    sortOrder
                };
                if (this.currentPage === 1) {
                    this.loadTickets();
                } else {
                    this.currentPage = 1;
                }
            },
            calculateNameToBeShown(complaint) {
                return complaint.code + "--" + complaint.description;
            },
            tableRowEscalationTime({ row, column }) {
                if (row.daysSinceRaised >= 0 && row.daysSinceRaised <= 4) {
                    return 'success-row';
                } else if (row.daysSinceRaised > 4 && row.daysSinceRaised <= 6) {
                    return 'warning-row';
                } else if (row.daysSinceRaised > 6) {
                    return 'error-row';
                } else {
                    return 'default-row';
                }
            },
        }
    };
</script>
<style>
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-table .error-row {
        background: #f2999a
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/servicetickets/components/ServiceTicketList.vue